const GPayIcon = ({ className = '' }) => (
  <svg
    width='31'
    height='13'
    viewBox='0 0 31 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <g clipPath='url(#clip0_11051_55806)'>
      <path
        d='M21.6221 3.74943C22.4468 3.74943 23.0841 3.97438 23.5715 4.42426C24.0588 4.87408 24.2837 5.47391 24.2837 6.22367V9.8225H23.2341V8.99785H23.1966C22.7467 9.67268 22.1094 10.0101 21.3596 10.0101C20.7223 10.0101 20.16 9.82256 19.7102 9.44773C19.2978 9.07285 19.0354 8.54803 19.0354 7.9857C19.0354 7.38586 19.2603 6.8985 19.7102 6.52361C20.16 6.14873 20.7973 5.99879 21.5471 5.99879C22.2219 5.99879 22.7467 6.11129 23.1591 6.37367V6.11129C23.1591 5.76137 23.0285 5.4115 22.7672 5.18352L22.7092 5.13658C22.4093 4.87414 22.0344 4.7242 21.6221 4.7242C20.9848 4.7242 20.4974 4.98662 20.16 5.51146L19.1854 4.91152C19.7851 4.12426 20.5724 3.74943 21.6221 3.74943ZM16.3362 1.2002C17.0089 1.2002 17.6481 1.43428 18.1593 1.8708L18.2481 1.9499C18.773 2.39979 19.0354 3.07461 19.0354 3.78688C19.0354 4.49914 18.773 5.13646 18.2481 5.62379C17.7233 6.11111 17.086 6.37355 16.3362 6.37355L14.5368 6.33605V9.8225H13.4121V1.2002H16.3362ZM21.772 6.89844C21.3221 6.89844 20.9473 7.0109 20.6474 7.23582C20.3475 7.42324 20.1975 7.68564 20.1975 8.02303C20.1975 8.32297 20.3475 8.58535 20.5724 8.73535C20.8348 8.92279 21.1347 9.03523 21.4346 9.03523C21.8545 9.03523 22.2744 8.87193 22.6028 8.57586L22.6717 8.51041C23.0466 8.17303 23.2341 7.76064 23.2341 7.31076C22.8967 7.04838 22.4093 6.89838 21.772 6.89838M16.4113 2.24979H14.5369V5.24902H16.4113C16.8236 5.24902 17.236 5.09908 17.4984 4.7992C18.0982 4.23688 18.0982 3.29967 17.5359 2.73729L17.4984 2.69979C17.1985 2.3999 16.8236 2.21246 16.4112 2.24996M30.3568 3.93688L26.6455 12.4467H25.5209L26.9079 9.48518L24.4712 3.97438H25.6708L27.4327 8.21053H27.4702L29.1947 3.97438H30.3568V3.93688Z'
        fill='#5F6368'
      />
      <path
        d='M10.0754 5.58637C10.0754 5.24898 10.0379 4.9116 10.0004 4.57422H5.31445V6.48613H7.97607C7.86363 7.0859 7.52625 7.64822 7.00143 7.98566V9.22275H8.6134C9.55061 8.36055 10.0754 7.0859 10.0754 5.58643'
        fill='#4285F4'
      />
      <path
        d='M5.31422 10.4224C6.66375 10.4224 7.7884 9.97252 8.61316 9.22275L7.00119 7.98566C6.55131 8.28555 5.98898 8.47299 5.31422 8.47299C4.03957 8.47299 2.91492 7.61078 2.54004 6.41113H0.890625V7.68572C1.75283 9.3727 3.4398 10.4224 5.31422 10.4224Z'
        fill='#34A853'
      />
      <path
        d='M2.54108 6.41111C2.3162 5.81129 2.3162 5.13652 2.54108 4.4992V3.22461H0.891665C0.179341 4.6117 0.179341 6.26117 0.891665 7.6857L2.54108 6.41111Z'
        fill='#FBBC04'
      />
      <path
        d='M5.31584 2.47486C6.0281 2.47486 6.70287 2.7373 7.22775 3.22463L8.65228 1.8001C7.75252 0.975332 6.55293 0.488008 5.35328 0.52545C3.47887 0.52545 1.75445 1.57516 0.929688 3.26213L2.57916 4.53672C2.91654 3.33707 4.04119 2.47486 5.31584 2.47486Z'
        fill='#EA4335'
      />
    </g>
    <defs>
      <clipPath id='clip0_11051_55806'>
        <rect
          width='30'
          height='11.9531'
          fill='white'
          transform='translate(0.357422 0.523438)'
        />
      </clipPath>
    </defs>
  </svg>
)

export default GPayIcon
